import { render } from "./index.vue?vue&type=template&id=d8c13ffc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d8c13ffc&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c13ffc"],['__file',"src/views/Formulario/Responder/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d8c13ffc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d8c13ffc', __exports__)) {
    console.log('reload')
    api.reload('d8c13ffc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=d8c13ffc&scoped=true", () => {
    console.log('re-render')
    api.rerender('d8c13ffc', render)
  })

}


export default __exports__